module.exports = __webpack_public_path__ + "img/second-day-12.8bf815c1.webp";